import { render, staticRenderFns } from "./FormFieldsetAnchors.vue?vue&type=template&id=09c65ba4"
import script from "./FormFieldsetAnchors.vue?vue&type=script&setup=true&lang=js"
export * from "./FormFieldsetAnchors.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports